__turbopack_context__.v({
  "workspaceMemberAvatar": "aDJW3W_workspaceMemberAvatar",
});
